(function(){
  var moved = false;
    // FP_FIRST_CALLOUT_HIGH 05/10/2026 (GO Mathéo) : 1er encart remonté après l'intro (~3e paragraphe, toujours avant le 2e H2).
    // Suivi maison 30 j : défilement moyen 39 %, 48 % des lecteurs ne voyaient aucun encart (ancien point = avant le H2 n° round(30 % des H2)).
    // Articles seulement (les guides .fp-pl gardent l'ancien point). Les autres encarts ne bougent pas (i1 garde l'ancien calcul).
    // Coupure naturelle : de préférence juste avant le titre (H2/H3) qui suit le 3e paragraphe ; jamais dans une liste/un tableau,
    // jamais entre une phrase « : » et sa liste, jamais collé à un autre encadré produit, jamais avant le 1er paragraphe.
    function fpEarlySlot(rte, h2s, card) {
      if (!rte.closest || rte.closest('.fp-pl')) return null;
      var limit = h2s[1] || null, kids = Array.prototype.filter.call(rte.children, function (e) { return e !== card; });
      var boxRe = /hb-recommendation-card|fp-quickpick|fp-cmp|fp-guide-box/;
      function isBox(el) { return !!el && (el.tagName === 'ASIDE' || el.tagName === 'TABLE' || el.hasAttribute('data-fp-callout') || boxRe.test(el.className || '')); }
      function isPara(el) { var t = (el.textContent || '').trim(); return el.tagName === 'P' && t.length >= 60 && !el.querySelector('img, iframe, video'); }
      function okAfter(i) { var t = (kids[i].textContent || '').trim(); return !/[:：]\s*$/.test(t) && !isBox(kids[i + 1]); }
      var end = limit ? kids.indexOf(limit) : kids.length; if (end < 0) end = kids.length;
      var count = 0, anchor = -1;
      for (var k = 0; k < end; k++) { if (isPara(kids[k])) { count++; if (count >= 2) anchor = k; if (count >= 3) break; } }
      if (anchor < 0) {
        // un seul paragraphe avant le 2e H2 : fin de la 1re partie
        if (count >= 1 && limit && !isBox(kids[end - 1])) return { before: limit };
        return null;
      }
      // titre qui suit l'ancre, à 3 paragraphes au plus
      var extra = 0;
      for (var j = anchor + 1; j <= end && j < kids.length; j++) {
        var el = kids[j];
        if (/^H[23]$/.test(el.tagName)) {
          var at = j; while (at - 1 > anchor && kids[at - 1].tagName === 'HR') at--; // avant le filet de séparation, pas entre le filet et le titre
          if (!isBox(kids[at - 1])) return { before: kids[at] };
          break;
        }
        if (isPara(el) && ++extra > 3) break;
      }
      // sinon après un paragraphe (l'ancre ou le suivant valable), toujours avant le 2e H2
      for (var q = anchor; q < end; q++) { if (isPara(kids[q]) && okAfter(q)) return { after: kids[q] }; }
      if (limit && !isBox(kids[end - 1])) return { before: limit };
      return null;
    }

  function tryMove() {
    if (moved || window.__fpCalloutsMoved) return true; // le script est chargé 2 fois par main-blog-post : une seule mise en place
    var rte = document.querySelector('rte-formatter') || document.querySelector('.article-template__content') || document.querySelector('.rte');
    var cards = document.querySelectorAll('[data-fp-callout]');
    var quiz  = document.querySelector('[data-fp-quiz-trigger-inline]');
    if (!rte) return false;

    // Collect substantive paragraphs (>30 chars) as anchors
    var paragraphs = [];
    rte.querySelectorAll(':scope > p').forEach(function(p){
      if ((p.textContent||'').trim().length > 30) paragraphs.push(p);
    });
    // Fallback if rte doesn't expose direct children
    if (paragraphs.length < 3) {
      rte.querySelectorAll('p').forEach(function(p){
        if ((p.textContent||'').trim().length > 30 && paragraphs.indexOf(p) === -1) paragraphs.push(p);
      });
    }
    if (paragraphs.length < 3) return false;

    // Find FAQ heading (if any) — used as a fence for card 2 placement
    var faqHeading = null;
    var headings = rte.querySelectorAll('h1, h2, h3');
    for (var i = 0; i < headings.length; i++) {
      var t = (headings[i].textContent || '').toLowerCase();
      if (/\bfaq\b|frequently\s+asked|frequently asked/i.test(t)) { faqHeading = headings[i]; break; }
    }

    // ===== POSITIONS (2026-06-21 rework — data scroll: 11% atteignent le bas, ~64s lus) =====
    // PRIMARY (cards[0])    → ~30% (apres intro + 1ere section, plus le tout en haut)
    // QUIZ                  → ~40% (legacy, quiz retire des articles donc inactif)
    // CROSS-SELL (cards[1]) → ~58% (avant le decrochage massif, plus en bas de page)
    var n = paragraphs.length;
    var i1 = -1;
    var allH2s = Array.prototype.slice.call(rte.querySelectorAll('h2'));
    // Filter to H2s that have meaningful content (skip empty/decorative)
    var h2s = allH2s.filter(function(h){
      var txt = (h.textContent || '').trim();
      if (txt.length <= 3) return false;
      // Skip the "Table of Contents" heading: le callout doit atterrir APRES la TOC,
      // pas avant (sinon il se colle a la table des matieres = bug chevauchement).
      if (/^(table of contents|contents|in this (guide|article))\b/i.test(txt)) return false;
      // Skip les H2 a l'interieur d'un <aside> stylise (tableau comparatif / recap).
      if (h.closest && h.closest('aside')) return false;
      return true;
    });

    function insertBeforeNode(node, target) {
      if (target && target.parentNode) {
        target.parentNode.insertBefore(node, target);
        return true;
      }
      return false;
    }

    // Slot 1 (PRIMARY) — ~30% (apres intro + 1ere section, plus le tout en haut)
    if (cards[0]) {
      var placed = false;
      if (h2s.length) {
        i1 = Math.min(h2s.length - 1, Math.max(1, Math.round(h2s.length * 0.30)));
      }
      // 05/10/2026 : point haut d'abord (articles), sinon ancien point ~30 % (i1 inchangé pour la carte 2 et l'encadré guide)
      var early = fpEarlySlot(rte, h2s, cards[0]);
      if (early && early.after && early.after.parentNode) { early.after.insertAdjacentElement('afterend', cards[0]); placed = true; }
      else if (early && early.before) placed = insertBeforeNode(cards[0], early.before);
      if (!placed && h2s.length) placed = insertBeforeNode(cards[0], h2s[i1]);
      if (!placed) {
        var p1 = Math.max(2, Math.floor(n * 0.30));
        if (paragraphs[p1]) { paragraphs[p1].insertAdjacentElement('afterend', cards[0]); placed = true; }
      }
      cards[0].removeAttribute('hidden');
    }

    // Slot 2 (QUIZ) — just before 3rd H2
    if (quiz && !rte.contains(quiz)) {
      var qPlaced = false;
      if (h2s[2]) qPlaced = insertBeforeNode(quiz, h2s[2]);
      // Fallbacks: before 2nd H2, before any FAQ heading, or paragraph ~40%
      if (!qPlaced && h2s[1]) qPlaced = insertBeforeNode(quiz, h2s[1]);
      if (!qPlaced && faqHeading) qPlaced = insertBeforeNode(quiz, faqHeading);
      if (!qPlaced) {
        var qFallbackIdx = Math.max(2, Math.floor(n * 0.40));
        if (paragraphs[qFallbackIdx]) paragraphs[qFallbackIdx].insertAdjacentElement('afterend', quiz);
      }
    }

    // Slot 3 (CROSS-SELL) — ~58% (avant le decrochage massif, plus en bas de page)
    if (cards[1]) {
      var xPlaced = false;
      if (h2s.length) {
        var i2 = Math.round(h2s.length * 0.58);
        if (i1 >= 0) i2 = Math.max(i2, i1 + 1);
        i2 = Math.min(h2s.length - 1, i2);
        if (i2 > i1) xPlaced = insertBeforeNode(cards[1], h2s[i2]);
      }
      if (!xPlaced && faqHeading) xPlaced = insertBeforeNode(cards[1], faqHeading);
      if (!xPlaced) {
        var xFallbackIdx = Math.min(n - 2, Math.max(3, Math.floor(n * 0.58)));
        if (paragraphs[xFallbackIdx]) paragraphs[xFallbackIdx].insertAdjacentElement('afterend', cards[1]);
      }
      cards[1].removeAttribute('hidden');
    }

    // FP_GUIDE_BOX 30/09/2026 : encadré guide d'achat vers 45 %, entre les deux cartes produit
    var gbox = document.querySelector('[data-fp-guide-box]');
    if (gbox && !rte.contains(gbox)) {
      var gPlaced = false;
      if (h2s.length >= 3) {
        // Jamais collé à une carte : les cartes sont insérées avant h2s[i1] et h2s[i2]
        var c1 = (i1 >= 0) ? i1 : -1, c2 = (typeof i2 === 'number') ? i2 : h2s.length;
        var gi = -1;
        if (c2 - c1 >= 2) gi = Math.floor((c1 + c2) / 2);
        else if (c2 + 1 < h2s.length) gi = c2 + 1;
        var gPrev = (gi > 0 && h2s[gi]) ? h2s[gi].previousElementSibling : null;
        if (gPrev && (gPrev.tagName === 'ASIDE' || gPrev.hasAttribute('data-fp-callout') || /fp-cmp/.test(gPrev.className || '')) && gi + 1 < h2s.length && gi + 1 !== c2) gi = gi + 1;
        if (gi > 0 && gi !== c1 && gi !== c2 && gi < h2s.length && h2s[gi] !== faqHeading) gPlaced = insertBeforeNode(gbox, h2s[gi]);
      }
      if (!gPlaced) { var gIdx = Math.min(n - 2, Math.max(3, Math.floor(n * 0.45))); if (paragraphs[gIdx]) { paragraphs[gIdx].insertAdjacentElement('afterend', gbox); gPlaced = true; } }
      if (gPlaced) gbox.removeAttribute('hidden');
    }

    // For starter-bundle articles, only one card is rendered (data-fp-key="starter-bundle")
    // Place it at quizIdx position if the quiz is absent, else at card1Idx.
    if (cards.length === 1 && cards[0].dataset.fpKey === 'starter-bundle') {
      var pos = Math.min(paragraphs.length - 1, Math.max(2, Math.floor(paragraphs.length * 0.3))); /* 05/10 : slotMidIdx n existait pas (plantage) */
      if (paragraphs[pos]) {
        paragraphs[pos].insertAdjacentElement('afterend', cards[0]);
        cards[0].removeAttribute('hidden');
      }
    }

    moved = true;
    window.__fpCalloutsMoved = true;
    return true;
  }

  function start() {
    if (tryMove()) return;
    var attempts = 0;
    var iv = setInterval(function(){
      attempts++;
      if (tryMove() || attempts > 40) clearInterval(iv);
    }, 200);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('load', start);
})();

/* FP_CMP — injecte le prix LIVE multi-devise (depuis #fp-cmp-price-map rendu par Liquid money) */
(function(){
  function injectCmpPrices(){
    var el = document.getElementById('fp-cmp-price-map');
    if (!el) return;
    var map;
    try { map = JSON.parse(el.textContent.replace(/,(\s*})/g,'$1').replace(/,\s*$/,'')); }
    catch(e){ return; }
    document.querySelectorAll('[data-fp-cmp-price]').forEach(function(span){
      var h = span.getAttribute('data-fp-cmp-price');
      if (map[h]) { span.textContent = map[h]; span.classList.remove('fp-cmp__price-now--sale'); }
    });
    // neutralise un eventuel prix barre "was" devenu trompeur quand le prix live remplace
    document.querySelectorAll('.fp-cmp__price-was').forEach(function(w){
      var card = w.closest('.fp-cmp');
      if (card && card.querySelector('[data-fp-cmp-price]')) w.style.display = 'none';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', injectCmpPrices);
  else injectCmpPrices();
})();
